/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// HAS TO BE `.js` CAUSE MIRAGE DOESN'T HAVE TYPE FOR `association`
import faker from 'faker';
import { Factory, association } from 'miragejs';

const businessPhone = Factory.extend({
  id: () => faker.datatype.uuid(),
  number: () => faker.phone.phoneNumberFormat().replace(/\W+/g, ''),
  digits_after_call: () => faker.random.alphaNumeric(),
  is_enabled_for_call_rescue: () => faker.datatype.boolean(),
  account: association(),
});

export default businessPhone;
